import { defineComponent as _defineComponent } from 'vue'
import AddOn from "@/models/Subscriptions/AddOns/AddOn";
import {useTranslations} from "@/hooks/useTranslations";
import {AddOnTypeName} from "@/models/Subscriptions/AddOns/AddOnTypeName";

type AddOnFormProps = {
  addOns: AddOn[]
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOnForm',
  props: {
    addOns: null
  },
  emits: ["addon-selected"],
  setup(__props: any, { emit }) {




const translations = useTranslations();

return { __sfc: true,emit, translations, AddOnTypeName }
}

})